import PageRegister from './components/Register';

export default PageRegister;